import { ReactNode } from 'react';

import classNames from 'classnames';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxPlaceholderProps {
  className?: string;
  children?: ReactNode;
}

export const ComboboxPlaceholder = ({ className, children }: ComboboxPlaceholderProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <span
      className={classNames(styles.placeholder(), contextClassNames?.placeholder, className)}
    >
      {children}
    </span>
  );
};
